// extracted by mini-css-extract-plugin
export default {"container":"G6BAnz","empty":"oUx6z0","highQualityFrame":"FC_567","lowQualityFrame":"J99wJK","thumbText":"ubVb_F"};